/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-fetch-md': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<defs><filter id="svgicon-icon-fetch-md-a"><feColorMatrix in="SourceGraphic" values="0 0 0 0 0.137255 0 0 0 0 0.262745 0 0 0 0 0.341176 0 0 0 1.000000 0"/></filter></defs><path pid="0" d="M7.572.246C11.128.246 14 3.276 14 7c0 3.724-2.872 6.754-6.428 6.754a.523.523 0 1 1 0-1.046c2.966 0 5.382-2.55 5.382-5.708 0-3.158-2.416-5.708-5.382-5.708-2.216 0-4.178 1.435-4.991 3.568l1.628-.547a.523.523 0 0 1 .42.953l-.087.038-2.697.908a.523.523 0 0 1-.594-.193l-.049-.086L.047 3.389a.523.523 0 0 1 .906-.514l.046.082.647 1.422C2.634 1.91 4.948.246 7.572.246z" _fill="#376F99" fill-rule="nonzero" filter="url(#svgicon-icon-fetch-md-a)"/>'
  }
})
